export interface ITank {
  deviceID: string
  sh?: string
  sp?: string
  tankId?: string
  name?: string
  country?: string
  zone?: string
  status?:string
  street?: string
  sensor: any
  settings: any
  info?: ITankInfo
  type: string
  capacity: number
  product: string
  productcode?:string
  quantity?:any
  materialname: string
  location: any
  suburb: string
  edi: any
  edisetup: boolean
  size: string
  equipment: string
  dporhe?: string
  alarmlevel: number
  time: any
  isalarmnotification: any
  isleveldropnotification: any
  pastLevelRaw: any
  pvalue?:number
  locationRaw: any
  deliverydatetime?: any
 
}
export interface ITankInfo {
  reorder?: number
  uom: string
  value: any
  lastUpdated?: number
  lastUpdatedDashBoard?:number
  data?: any
  dporhe?: string
  valuepast: any
  dataPast?: any
  assetnoofdays?: any
 
}

export interface UsagePeriod {
  from: Date
  to: Date
}

export enum Error {
  NONE = '',
  NETWORK_ERROR = 'Network Error',
  UNEXPECTED_ERROR = 'Unexpected Error',
  DEVICE_NOT_FOUND = 'Device not found',
  DEVICE_ASSIGNED = 'Device already assigned',
  CUSTOMER_NOT_FOUND = 'Customer not found',
  NOTIFICATION_ERROR_PERMISSION_DENIED = 'Currently, the site is blocked from sending notifications. Please unblock the same in your browser settings',
  NOTIFICATION_ERROR_PERMISSION_NOT_GRANTED = 'You need to allow the site to send notifications',
  NOTIFICATION_ERROR_UNABLE_TO_SUBCRIBE = 'Unable to subscribe you to notifications',
  INVALID_WORKING_HOUR_ERROR = 'Start time can not be after End time',
}

export enum Role {
  UNAUTHENTICATED,
  ADMIN,
  FITTER,
  CUSTOMER,
  CLT,
}

export interface User {
  role: Role
  country:string
  zone: string
  userName: string
  customerId: string
  countryFilter: any
  stateFilter:any
}

export interface ISubscription {
  address: string
  type: string
  optOut: 'ALL' | 'NONE'
}

export enum ChannelType {
  GCM = 'GCM',
  APNS = 'APNS',
  APNS_SANDBOX = 'APNS_SANDBOX',
  SMS = 'SMS',
  EMAIL = 'EMAIL'
}
